import moment from "moment-timezone";
import { TIMELINE_TYPE } from "../../../../constants";
import { TIMELINE_BUFFER } from "../constants";
import { DateRange } from "../types";

export const getExtendedDateRange = (baseDate: Date | null, view: string, timezone: string): DateRange => {
  const currentDate = baseDate ? moment(baseDate).tz(timezone) : moment().tz(timezone);

  const config: Record<string, { units: number; type: moment.unitOfTime.DurationConstructor }> = {
    [TIMELINE_TYPE.DAY]: { units: TIMELINE_BUFFER.DAY, type: "days" },
    [TIMELINE_TYPE["3DAY"]]: { units: TIMELINE_BUFFER["3DAY"], type: "days" },
    [TIMELINE_TYPE.WEEK]: { units: TIMELINE_BUFFER.WEEK, type: "days" },
    [TIMELINE_TYPE.MONTH]: { units: TIMELINE_BUFFER.MONTH, type: "months" },
  };

  const { units, type } = config[view] ?? config[TIMELINE_TYPE.DAY];

  return {
    min: currentDate.clone().subtract(units, type).startOf("day").toDate(),
    max: currentDate.clone().add(units, type).endOf("day").toDate(),
  };
};
